// Legacy follow-ups have stable IDs but no structured action type.
// Keep their labels explicit rather than guessing from editable task titles.
const actions = {
  'avenir-followup-cf-2025-012024': ['Confirm court-case status', 'court-case status'],
  'collins-appeal-status-21415-27029': ['Confirm appeal status', 'appeal status'],
  'icon-followup-appeal-20295': ['Confirm appeal status', 'appeal status'],
  'falls-village-followup-cf-2026-117246': ['Confirm balance and status', 'balance and City status'],
  'hathaway-house-followup-cf-2026-084214': ['Record inspection update', 'inspection update'],
  'icon-followup-cf-2026-115009': ['Confirm responsibility and status', 'responsibility and status'],
  'icon-followup-cf-2026-136191': ['Confirm benchmarking status', 'benchmarking status'],
}

export function followupLabels(task) {
  const id = String(task.id || '')
  const [action, subject] = id.startsWith('certification-coverage-')
    ? ['Confirm coverage', 'coverage']
    : task.kind === 'highRiseApplicabilityVerification' || id.startsWith('high-rise-applicability-')
      ? ['Confirm high-rise requirement', 'high-rise requirement']
      : actions[id] || ['Record findings', 'findings']
  return {
    button: task.status === 'in_review' ? `Review ${subject}`
      : task.status === 'complete' ? `View verified ${subject}` : action,
    field: task.status === 'in_review' ? 'Verification note' : `${subject[0].toUpperCase()}${subject.slice(1)} and supporting details`,
  }
}
